import React from "react";
import { Message } from "components/generic/layout";

export default ({ text }) => (
  <Message
    title="Invitation sent successfully! Your referral will receive a secret invitation link to join The Lobby shortly."
    text={text}
    showIcon
  />
);



// WEBPACK FOOTER //
// ./src/components/common/referral/Success/index.js